<script setup lang="ts">
import { onMounted } from "vue";
import { useAuthStore } from "@/stores/auth.js";
import AppHeader from "@/components/AppHeader.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

const authStore = useAuthStore();

onMounted(() => {
    authStore.initialize();
});
</script>

<template>
    <div v-if="authStore.loading" class="app-loading">
        <LoadingSpinner size="lg" />
    </div>

    <template v-else>
        <AppHeader v-if="authStore.isAuthenticated" />
        <main class="main-content">
            <div class="container">
                <router-view />
            </div>
        </main>
    </template>
</template>

<style scoped>
.app-loading {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
